import { useEffect } from "react";
import { setSEO } from "@/lib/api";

const SIZES = ["XS", "S", "M", "L", "XL"];

const TABLES = [
  {
    title: "Tops · Crops · Baby Tees",
    note: "Tanks and baby tees are fitted. Size up for a softer fit.",
    rows: [
      ["Bust (in)", "30-32", "32-34", "34-36", "36-38", "38-40"],
      ["Waist (in)", "23-25", "25-27", "27-29", "29-31", "31-33"],
      ["Length (in)", "14", "14.5", "15", "15.5", "16"],
    ],
  },
  {
    title: "Sports Bras",
    note: "Compressive medium-impact hold. True to size for lifts. Size up for relaxed.",
    rows: [
      ["Underbust (in)", "25-27", "27-29", "29-31", "31-33", "33-35"],
      ["Cup fit", "A/B", "B/C", "C/D", "D/DD", "DD/E"],
    ],
  },
  {
    title: "Biker Shorts",
    note: "Squat-tested. Never sheer. Contoured high-rise waistband. Fit snug but not sheer.",
    rows: [
      ["Waist (in)", "23-25", "25-27", "27-29", "29-31", "31-33"],
      ["Hip (in)", "33-35", "35-37", "37-39", "39-41", "41-43"],
      ["Inseam (in)", "8", "8", "8.5", "8.5", "9"],
    ],
  },
  {
    title: "Joggers",
    note: "Relaxed mid-rise unless noted. Tapered ankle.",
    rows: [
      ["Waist (in)", "24-26", "26-28", "28-30", "30-32", "32-34"],
      ["Hip (in)", "34-36", "36-38", "38-40", "40-42", "42-44"],
      ["Inseam (in)", "28.5", "29", "29.5", "30", "30.5"],
    ],
  },
];

export default function Sizing() {
  useEffect(() => {
    setSEO({
      title: "Sizing Guide | FEMBOT NEX",
      description:
        "FEMBOT NEX size guide. Tops, sports bras, biker shorts, and joggers. Fit notes for cyber-femme activewear.",
    });
  }, []);

  return (
    <div data-testid="sizing-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="section-label">// SIZING & FIT</div>
      <h1 className="mt-3 font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
        Fit like you <span className="text-[#ff1493]">mean it</span>.
      </h1>
      <p className="mt-6 max-w-2xl text-[#a3a3a3] leading-relaxed">
        Final fit notes may update after sample review. When in doubt, size up for a softer fit. Measurements in inches.
      </p>

      <ul className="mt-10 grid sm:grid-cols-2 gap-3 max-w-3xl">
        {[
          "Tanks and baby tees are fitted.",
          "Sports bras are compressive.",
          "Biker shorts should fit snug but not sheer.",
          "Joggers are relaxed unless noted.",
          "Size up for a softer fit.",
          "Final fit notes may update after sample review.",
        ].map((t, i) => (
          <li key={i} className="border border-[#262626] p-4 font-mono text-[12px] tracking-[0.1em] text-[#a3a3a3]">
            <span className="text-[#ff1493] mr-2">//</span>
            {t}
          </li>
        ))}
      </ul>

      <div className="mt-16 space-y-16">
        {TABLES.map((t) => (
          <div key={t.title} data-testid={`sizing-table-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <h2 className="font-display text-2xl md:text-3xl tracking-tight">{t.title}</h2>
            <p className="mt-2 font-mono text-[11px] tracking-[0.2em] uppercase text-[#6b6b6b]">
              // {t.note}
            </p>
            <div className="mt-4 overflow-x-auto border border-[#262626]">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-black">
                    <th className="text-left font-mono text-[11px] tracking-[0.2em] uppercase text-[#ff1493] px-4 py-3 border-b border-[#262626]">
                      Measure
                    </th>
                    {SIZES.map((s) => (
                      <th
                        key={s}
                        className="text-left font-mono text-[11px] tracking-[0.2em] uppercase text-white px-4 py-3 border-b border-[#262626]"
                      >
                        {s}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {t.rows.map((r, i) => (
                    <tr key={i} className="border-b border-[#1a1a1a] last:border-b-0">
                      {r.map((cell, j) => (
                        <td
                          key={j}
                          className={`px-4 py-3 ${
                            j === 0
                              ? "font-mono text-[11px] tracking-[0.1em] uppercase text-[#a3a3a3]"
                              : "font-mono text-sm text-white"
                          }`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
